import pkg from 'lodash';

const { cloneDeep: DeepCloneLodash } = pkg;

export const deepClone = (data: any) => {
  return DeepCloneLodash(data);
};
